import request from '@/utils/request';

export default {
    getDriversWithTokens: async({ dispatch, commit }, data) => {
        await request({
            method: 'post',
            url: '/admin/notifications/drivers',
            timeout: 10000,
            data
        }).then(res => {
            if (res.data) {
                if(!res.data.count) {
                    dispatch('alert/addMessage', {
                        message: 'notifications.noRecords'
                    }, { root: true });
                }
                commit('SET_DRIVERS', res.data);
            }
        }).catch(error => {
            if(error.response && error.response.data && error.response.data.error) {
                dispatch('alert/addMessage', {
                    message: error.response.data.error
                }, { root: true });
            }
        });
    },

    sendNotification: async({ dispatch }, data) => {
        return await request({ method: 'post', url: '/admin/notifications', timeout: 10000, data })
            .then(res => {
                if (res.data) {
                    return res.data;
                }
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: `notifications.${error.response.data.error}`
                    }, { root: true });
                }
            });
    }
};
